/*
* @Author: Johnny.liu
* @Date:   2021-03-08 13:48:41
* @Last Modified by:   Johnny.liu
* @Last Modified time: 2021-03-30 15:38:31
*/
import { param } from "jquery";
import { HTTP } from "../../lib/http"
import url from "../../lib/url";

export const APIService = {

	http: HTTP,

	async getUrlData (url, param) {
		return await this.http.postImmediately({
			type: 'post',
			url: url,
			data: param
		});
	},

	/**
	 * [SaveProject 新增/编辑项目管理接口]
	 * @param {[type]} param [data: 新增数据dict]
	 * @param {[type]} param [row_id: 编辑时传参，所在行id]
	 */
	async SaveProject (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/save_project/',
			data: param
		});
	},

	/**
	 * [GetProjectDetail 项目管理查看接口]
	 * @param {[type]} param [row_id: 项目列表当前行id]
	 */
	async GetProjectDetail (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_project_detail/',
			data: param
		});
	},
	
	/**
	 * [FastCreateWorkflow 投资顾问信息添加]
	 * @param {[type]} param [description]
	 */
	async FastCreateWorkflow (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/fast_create_workflow/',
			data: param
		});
	},

	/**
	 * [FastCreateWorkflow 审批工作流]
	 * @param {[type]} param [action: 0 通过, 1: 驳回到上一级, 2: 驳回到发起人]
	 */
	async ApproveWorkflow (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/approve_workflow_record/',
			data: param
		});
	},
	/**
	 * [GetInstructions 获取投资顾问使用须知信息]
	 * @param {[type]} param [description]
	 */
	async GetInstructions (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_instructions/',
			data: param
		});
	},

	/**
	 * [GetDeptList 获取部门列表]
	 * @param {[type]} param [description]
	 */
	async GetDeptList (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_department_list/',
			data: param
		});
	},

	/**
	 * [GetUserList 获取人员列表]
	 * @param {[type]} param [description]
	 */
	async GetUserList (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_user_list/',
			data: param
		});
	},

	/**
	 * [GetBankList 获取托管银行信息]
	 * @param {[type]} param [description]
	 */
	async GetBankList (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_bank_list/',
			data: param
		});
	},

	/**
	 * [GetRecordTips 获取审批记录]
	 * @param {[type]} param [description]
	 */
	async GetRecordTips (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_record_tips/',
			data: param
		});
	},

	/**
	 * [GetInvestmentConsultant 获取投资顾问相关数据]
	 * @param {[type]} param [description]
	 */
	async GetInvestmentConsultant (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_investment_consultant/',
			data: param
		});
	},

	/**
	 * [GetProjectPermissionInfo 获取项目管理中的权限相关的信息]
	 * @param {[type]} param [description]
	 */
	async GetProjectPermissionInfo (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_project_permission_info/',
			data: param
		});
	},

	/**
	 * [AddProjectPermission 创建项目管理的权限]
	 * @param {[type]} param [description]
	 */
	async AddProjectPermission (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/add_project_permission/',
			data: param
		});
	},

	/**
	 * [getInvestmentConsultantChangeInfo 变动记录详情]
	 * @param {[type]} param [description]
	 */
	 async getInvestmentConsultantChangeInfo (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_investment_consultant_change_info/',
			data: param
		});
	},

	/**
	 * [getInvestmentConsultantChangeList 变动记录详情]
	 * @param {[type]} param [description]
	 */
	 async getInvestmentConsultantChangeList (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_investment_consultant_change_list/',
			data: param
		});
	},


	/**
	 * [getInvestmentAdviserDepartment 部门信息]
	 * @param {[type]} param [description]
	 */
	async getInvestmentAdviserDepartment () {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_investment_adviser_department/',
		});
	},
}


// WEBPACK FOOTER //
// app/services/projectManager/api.js